exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AuthorizedNavigationBar__nav__25jXy{width:100%;padding-left:1em;position:relative;transform:none;top:auto;left:auto}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/Header/src/components/Header/AuthorizedNavigationBar.scss"],"names":[],"mappings":"AAAA,qCACE,WAAW,AACX,iBAAiB,AACjB,kBAAkB,AAClB,eAAe,AACf,SAAS,AACT,SAAU,CACX","file":"AuthorizedNavigationBar.scss","sourcesContent":[".nav {\n  width: 100%;\n  padding-left: 1em;\n  position: relative;\n  transform: none;\n  top: auto;\n  left: auto;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"nav": "AuthorizedNavigationBar__nav__25jXy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/Header/AuthorizedNavigationBar.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/Header/AuthorizedNavigationBar.scss
// module chunks = 0